import React from 'react'
import { Outlet } from 'react-router-dom'
import Layout from '../../components/layouts/Layout'
import AcademicsLayout from '../../components/layouts/AcademicsLayout'

const Academics = () => {
  return (
    <Layout pageTitle={`Academics`}>
        <AcademicsLayout>
            <Outlet />
        </AcademicsLayout>
    </Layout>
  )
}

export default Academics